/* vue-kerlink version 3.0.3 */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script = {
  props: {
    // Title
    title: {
      type: String,
      default: ''
    },
    // Sub-title of the grid displayed in the panel header small
    titleSmall: {
      type: String,
      default: ''
    },
    // Hide header
    noHeader: {
      type: Boolean,
      default: false
    },
    // Hide body (to use card-table)
    noBody: {
      type: Boolean,
      default: false
    },
    // Hide footer
    noFooter: {
      type: Boolean,
      default: false
    },
    // Remove root padding inside card
    noPadding: {
      type: Boolean,
      default: false
    },
    // Allow card to be collapsed
    collapsible: {
      type: Boolean,
      default: false
    },
    // Default state when collapsible is true
    visible: {
      type: Boolean,
      default: true
    },
    // Add a gray overlay to disable panel
    disabled: {
      type: Boolean,
      default: false
    },
    // Text displayed on the disabled overlay
    disabledText: {
      type: String,
      default: 'Not available'
    }
  },

  data () {
    return {
      collapsed: !this.visible
    }
  },

  watch: {
    visible (visible) {
      this.collapsed = !visible;
    }
  },

  methods: {
    toggle () {
      this.collapsed = !this.collapsed;
      this.$emit('update:visible', !this.collapsed);
    },

    enter (el) {
      el.style.height = 'auto';
      const realHeight = getComputedStyle(el).height;
      el.style.height = '0px';

      /* eslint-disable no-unused-expressions */
      el.offsetHeight; // Force repaint

      el.style.height = realHeight;
    },

    leave (el) {
      el.style.height = 'auto';
      const realHeight = getComputedStyle(el).height;
      el.style.height = realHeight;

      /* eslint-disable no-unused-expressions */
      el.offsetHeight; // Force repaint

      el.style.height = '0px';
    },

    clearHeight (el) {
      el.style.height = null;
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function () {
      style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

var normalizeComponent_1 = normalizeComponent;

var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
  return function (id, style) {
    return addStyle(id, style);
  };
}
var HEAD = document.head || document.getElementsByTagName('head')[0];
var styles = {};

function addStyle(id, css) {
  var group = isOldIE ? css.media || 'default' : id;
  var style = styles[group] || (styles[group] = {
    ids: new Set(),
    styles: []
  });

  if (!style.ids.has(id)) {
    style.ids.add(id);
    var code = css.source;

    if (css.map) {
      // https://developer.chrome.com/devtools/docs/javascript-debugging
      // this makes source maps inside style tags work properly in Chrome
      code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'; // http://stackoverflow.com/a/26603875

      code += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) + ' */';
    }

    if (!style.element) {
      style.element = document.createElement('style');
      style.element.type = 'text/css';
      if (css.media) style.element.setAttribute('media', css.media);
      HEAD.appendChild(style.element);
    }

    if ('styleSheet' in style.element) {
      style.styles.push(code);
      style.element.styleSheet.cssText = style.styles.filter(Boolean).join('\n');
    } else {
      var index = style.ids.size - 1;
      var textNode = document.createTextNode(code);
      var nodes = style.element.childNodes;
      if (nodes[index]) style.element.removeChild(nodes[index]);
      if (nodes.length) style.element.insertBefore(textNode, nodes[index]);else style.element.appendChild(textNode);
    }
  }
}

var browser = createInjector;

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "card border-primary mb-3",
      class: {
        "card-collapsible": _vm.collapsible,
        collapsed: _vm.collapsed,
        disabled: _vm.disabled
      }
    },
    [
      _vm.disabled
        ? _c("div", { staticClass: "disabled-overlay-text" }, [
            _vm._v(_vm._s(_vm._f("capitalize")(_vm.disabledText)))
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.disabled ? _c("div", { staticClass: "disabled-overlay" }) : _vm._e(),
      _vm._v(" "),
      !_vm.noHeader
        ? _c(
            "div",
            {
              staticClass:
                "card-header d-flex justify-content-between align-items-center",
              on: {
                click: function($event) {
                  _vm.collapsible ? _vm.toggle() : null;
                }
              }
            },
            [
              _c(
                "div",
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm._f("capitalize")(_vm.title)) +
                      "\n      "
                  ),
                  _vm.titleSmall
                    ? _c("small", [
                        _vm._v(_vm._s(_vm._f("capitalize")(_vm.titleSmall)))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.titleSmall ? _vm._t("card-title-small") : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex" },
                [
                  !_vm.collapsed ? _vm._t("card-header-right") : _vm._e(),
                  _vm._v(" "),
                  _vm.collapsible
                    ? _c("span", {
                        staticClass:
                          "card-collapsible-button icon-angle-right ml-2"
                      })
                    : _vm._e()
                ],
                2
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "transition",
        {
          attrs: { name: "collapse" },
          on: {
            enter: _vm.enter,
            "after-enter": _vm.clearHeight,
            leave: _vm.leave,
            "after-leave": _vm.clearHeight
          }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.collapsed,
                  expression: "!collapsed"
                }
              ],
              class: { "collapsible-panel-content": _vm.collapsible }
            },
            [
              !_vm.noBody
                ? _c(
                    "div",
                    {
                      staticClass: "card-body",
                      class: { "p-0": _vm.noPadding }
                    },
                    [_vm._t("card-body")],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.noBody ? _vm._t("card-table") : _vm._e(),
              _vm._v(" "),
              !_vm.noFooter
                ? _c(
                    "div",
                    { staticClass: "card-footer" },
                    [_vm._t("card-footer")],
                    2
                  )
                : _vm._e()
            ],
            2
          )
        ]
      )
    ],
    1
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-4225ef18_0", { source: ".card.card-collapsible .card-header[data-v-4225ef18] {\n  cursor: pointer;\n}\n.card.card-collapsible .card-header .icon-angle-right[data-v-4225ef18] {\n  display: inline-block;\n  transition: all 0.35s ease;\n  transform: rotate(90deg);\n}\n.card.card-collapsible.collapsed .icon-angle-right[data-v-4225ef18] {\n  transform: rotate(0deg);\n}\n.card.card-collapsible .collapse-enter-active[data-v-4225ef18],\n.card.card-collapsible .collapse-leave-active[data-v-4225ef18] {\n  overflow: hidden;\n  transition: all 0.35s ease;\n}\n.card .disabled-overlay-text[data-v-4225ef18] {\n  position: absolute;\n  top: calc(50% - 20px);\n  z-index: 1021;\n  width: 100%;\n  padding: 0 10%;\n  line-height: 20px;\n  color: #000;\n  text-align: center;\n}\n.card .disabled-overlay[data-v-4225ef18] {\n  position: absolute;\n  z-index: 1020;\n  width: 100%;\n  height: 100%;\n  background: #dee2e6;\n  border: 1px solid #bbb;\n  border-radius: 0.25rem;\n  opacity: 0.8;\n}\n\n/*# sourceMappingURL=Card.vue.map */", map: {"version":3,"sources":["C:\\Users\\alg\\Workspace_Dashboard\\vue-kerlink\\src\\components\\Card.vue","Card.vue"],"names":[],"mappings":"AAkJA;EACA,eAAA;ACjJA;ADmJA;EACA,qBAAA;EACA,0BAAA;EACA,wBAAA;ACjJA;ADsJA;EACA,uBAAA;ACpJA;ADwJA;;EAEA,gBAAA;EACA,0BAAA;ACtJA;AD0JA;EACA,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;ACxJA;AD2JA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;EACA,sBAAA;EACA,YAAA;ACzJA;;AAEA,mCAAmC","file":"Card.vue","sourcesContent":["<template>\n  <div :class=\"{'card-collapsible': collapsible, collapsed, disabled}\" class=\"card border-primary mb-3\">\n    <div v-if=\"disabled\" class=\"disabled-overlay-text\">{{ disabledText | capitalize }}</div>\n    <div v-if=\"disabled\" class=\"disabled-overlay\" />\n\n    <div v-if=\"!noHeader\" class=\"card-header d-flex justify-content-between align-items-center\" @click=\"collapsible ? toggle() : null\">\n      <div>\n        {{ title | capitalize }}\n        <small v-if=\"titleSmall\">{{ titleSmall | capitalize }}</small>\n        <slot v-if=\"!titleSmall\" name=\"card-title-small\" />\n      </div>\n\n      <div class=\"d-flex\">\n        <slot v-if=\"!collapsed\" name=\"card-header-right\" />\n        <span v-if=\"collapsible\" class=\"card-collapsible-button icon-angle-right ml-2\" />\n      </div>\n    </div>\n\n    <transition name=\"collapse\"\n                @enter=\"enter\"\n                @after-enter=\"clearHeight\"\n                @leave=\"leave\"\n                @after-leave=\"clearHeight\"\n    >\n      <div v-show=\"!collapsed\" :class=\"{ 'collapsible-panel-content':collapsible }\">\n        <div v-if=\"!noBody\" :class=\"{ 'p-0': noPadding }\" class=\"card-body\">\n          <slot name=\"card-body\" />\n        </div>\n\n        <slot v-if=\"noBody\" name=\"card-table\" />\n\n        <div v-if=\"!noFooter\" class=\"card-footer\">\n          <slot name=\"card-footer\" />\n        </div>\n      </div>\n    </transition>\n  </div>\n</template>\n\n<script>\nexport default {\n  props: {\n    // Title\n    title: {\n      type: String,\n      default: ''\n    },\n    // Sub-title of the grid displayed in the panel header small\n    titleSmall: {\n      type: String,\n      default: ''\n    },\n    // Hide header\n    noHeader: {\n      type: Boolean,\n      default: false\n    },\n    // Hide body (to use card-table)\n    noBody: {\n      type: Boolean,\n      default: false\n    },\n    // Hide footer\n    noFooter: {\n      type: Boolean,\n      default: false\n    },\n    // Remove root padding inside card\n    noPadding: {\n      type: Boolean,\n      default: false\n    },\n    // Allow card to be collapsed\n    collapsible: {\n      type: Boolean,\n      default: false\n    },\n    // Default state when collapsible is true\n    visible: {\n      type: Boolean,\n      default: true\n    },\n    // Add a gray overlay to disable panel\n    disabled: {\n      type: Boolean,\n      default: false\n    },\n    // Text displayed on the disabled overlay\n    disabledText: {\n      type: String,\n      default: 'Not available'\n    }\n  },\n\n  data () {\n    return {\n      collapsed: !this.visible\n    }\n  },\n\n  watch: {\n    visible (visible) {\n      this.collapsed = !visible\n    }\n  },\n\n  methods: {\n    toggle () {\n      this.collapsed = !this.collapsed\n      this.$emit('update:visible', !this.collapsed)\n    },\n\n    enter (el) {\n      el.style.height = 'auto'\n      const realHeight = getComputedStyle(el).height\n      el.style.height = '0px'\n\n      /* eslint-disable no-unused-expressions */\n      el.offsetHeight // Force repaint\n\n      el.style.height = realHeight\n    },\n\n    leave (el) {\n      el.style.height = 'auto'\n      const realHeight = getComputedStyle(el).height\n      el.style.height = realHeight\n\n      /* eslint-disable no-unused-expressions */\n      el.offsetHeight // Force repaint\n\n      el.style.height = '0px'\n    },\n\n    clearHeight (el) {\n      el.style.height = null\n    }\n  }\n}\n</script>\n\n<style scoped lang=\"scss\">\n  @import \"../scss/variables\";\n\n  .card {\n    &.card-collapsible {\n      .card-header {\n        cursor: pointer;\n\n        .icon-angle-right {\n          display: inline-block;\n          transition: all 0.35s ease;\n          transform: rotate(90deg);\n        }\n      }\n\n      &.collapsed {\n        .icon-angle-right {\n          transform: rotate(0deg);\n        }\n      }\n\n      .collapse-enter-active,\n      .collapse-leave-active {\n        overflow: hidden;\n        transition: all 0.35s ease;\n      }\n    }\n\n    .disabled-overlay-text {\n      position: absolute;\n      top: calc(50% - 20px);\n      z-index: 1021;\n      width: 100%;\n      padding: 0 10%;\n      line-height: 20px;\n      color: $black;\n      text-align: center;\n    }\n\n    .disabled-overlay {\n      position: absolute;\n      z-index: 1020;\n      width: 100%;\n      height: 100%;\n      background: $gray-300;\n      border: 1px solid $gray-500;\n      border-radius: $border-radius;\n      opacity: 0.8;\n    }\n  }\n</style>\n",".card.card-collapsible .card-header {\n  cursor: pointer;\n}\n.card.card-collapsible .card-header .icon-angle-right {\n  display: inline-block;\n  transition: all 0.35s ease;\n  transform: rotate(90deg);\n}\n.card.card-collapsible.collapsed .icon-angle-right {\n  transform: rotate(0deg);\n}\n.card.card-collapsible .collapse-enter-active,\n.card.card-collapsible .collapse-leave-active {\n  overflow: hidden;\n  transition: all 0.35s ease;\n}\n.card .disabled-overlay-text {\n  position: absolute;\n  top: calc(50% - 20px);\n  z-index: 1021;\n  width: 100%;\n  padding: 0 10%;\n  line-height: 20px;\n  color: #000;\n  text-align: center;\n}\n.card .disabled-overlay {\n  position: absolute;\n  z-index: 1020;\n  width: 100%;\n  height: 100%;\n  background: #dee2e6;\n  border: 1px solid #bbb;\n  border-radius: 0.25rem;\n  opacity: 0.8;\n}\n\n/*# sourceMappingURL=Card.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-4225ef18";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  

  
  var Card = normalizeComponent_1(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    browser,
    undefined
  );

export default Card;
